<template>
  <Card
    v-if="title || content || linkURL"
    :elevation="elevation"
    class="flex flex-row items-start justify-center w-full"
    :href="linkURL"
    :clickable="clickable"
    :target="openInNewTab ? '_blank' : '_self'"
    :useFullPageNavigation="useFullPageNavigation"
    :aria-label="linkDescription"
    @click="$emit('click')"
  >
    <div v-if="hasLeftSide" :class="leftSideClasses">
      <slot name="leftSide" />
    </div>
    <div class="flex-1 my-auto">
      <div class="flex flex-col gap-8">
        <h3 v-if="title" :class="`text-${titleColor}`" class="text-strong-body">{{ title }}</h3>
        <p v-if="content" :class="`text-${contentColor}`" class="text-small">{{ content }}</p>
        <slot name="content" />
      </div>
      <Button v-if="linkValue" :value="linkValue" variant="text" class="mt-8 px-0 text-left" />
    </div>
    <div class="my-auto">
      <slot name="rightSide" />
    </div>
  </Card>
</template>

<script lang="ts">
import Button from '../button/Button.vue';
import Card from '../card/Card.vue';

export default {
  name: 'ImageLinkCard',
  components: { Button, Card },
  props: {
    title: {
      type: String,
      default: '',
    },
    titleColor: {
      type: String,
      default: 'grey-header',
    },
    content: {
      type: String,
      default: '',
    },
    contentColor: {
      type: String,
      default: 'grey-body',
    },
    linkValue: {
      type: String,
      default: '',
    },
    linkURL: {
      type: String,
      default: '',
    },
    openInNewTab: {
      type: Boolean,
      default: false,
    },
    useFullPageNavigation: {
      type: Boolean,
      default: false,
    },
    linkDescription: {
      type: String,
      default: '',
    },
    elevation: {
      type: Number,
      default: 3,
    },
    leftSideWidth: {
      type: String,
      default: 'w-64',
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasLeftSide(): Boolean {
      return !!this.$slots.leftSide;
    },
    leftSideClasses(): String {
      return `my-auto ${this.leftSideWidth}`;
    },
  },
};
</script>
